import { type ChallengeSummary, type TaskSummary } from '@/lib/types';
import TagsWrapper from './TagsWrapper';
import PortfolioItemTag from './PortfolioItemTag';
import HiddenTagsCount from './HiddenTagsIndicator';
import sortByName from '@/lib/utils/sorting/sortByName';

type PortfolioItemCardTagsProps = {
  portfolioItem: ChallengeSummary | TaskSummary;
};

const PortfolioItemCardTags = ({
  portfolioItem,
}: PortfolioItemCardTagsProps) => {
  const tags = [...portfolioItem.tags].sort(sortByName);

  return (
    <TagsWrapper>
      {portfolioItem.tags.length > 4 ? (
        <>
          {tags.slice(0, 3).map(tag => (
            <PortfolioItemTag tagColor={tag.color} key={tag.id}>
              {tag.name}
            </PortfolioItemTag>
          ))}
          <HiddenTagsCount
            count={portfolioItem.tags.length - 3}
            portfolioItemColor={portfolioItem.color}
          />
        </>
      ) : (
        <>
          {tags.map(tag => (
            <PortfolioItemTag tagColor={tag.color} key={tag.id}>
              {tag.name}
            </PortfolioItemTag>
          ))}
        </>
      )}
    </TagsWrapper>
  );
};

export default PortfolioItemCardTags;
